import type { SiteVariant } from "@/context/VariantContext";

/**
 * Generic wrapper for variant-specific content.
 * Ensures both variants have the same structure.
 */
export type VariantContent<T> = Record<SiteVariant, T>;

/**
 * Helper to get content for current variant.
 *
 * @example
 * ```tsx
 * const { variant } = useVariant();
 * const content = getContent(heroContent, variant);
 * return <h1>{content.greeting}</h1>;
 * ```
 */
export function getContent<T>(
  content: VariantContent<T>,
  variant: SiteVariant,
): T {
  return content[variant];
}
